function Document() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <path d="M12 5h18l7 7v31H12z" />
      <path d="M30 5v8h7" />
      <path d="M18 22h13" />
      <path d="M18 29h13" />
      <path d="M18 36h9" />
    </svg>
  );
}

export default Document;
